<ul class="nav flex-column p-0">
  <li class="nav-item">
    <a (click)="click()" class="nav-link nav-link-collapse" [attr.aria-expanded]="!isCollapsed? 'true': 'false'">
      <i class="{{icons()}}"></i>
      <span>{{ name() }}</span>
      <i class="rtl:rotate-180 right-icon"
         x-bind:style="selected.includes('menu_style') ? 'transform:  rotate(90deg)' : ''">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" fill="none" viewBox="0 0 24 24"
             stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
        </svg>
      </i>
    </a>
  </li>
  <div class="collapse" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
    <ng-content></ng-content>
  </div>
</ul>
